import React, { useEffect, useState } from "react";

import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { getDropdownCountryList } from "../../../../service/rak-beneficiary-service";

const RaKBeneficiaryFilter = ({
  show = false,
  onHide,
  saveButtonClicked,
  setType,
  type,
  setCountry,
  country,
  setStatus,
  status,
}) => {
  // const [type, setType] = useState([]);
  // const [country, setCountry] = useState([]);
  // const [status, setStatus] = useState([]);
  const [typeLength, setTypeLength] = useState(0);
  const [countryLength, setCountryLength] = useState(0);
  const [statusLength, setStatusLength] = useState(0);

  const [typeList, setTypeList] = useState([
    { value: "CashPickUP", label: "Cash Pickup" },
    { value: "BankTransfer", label: "Bank Transfer" },
  ]);
  const [countryList, setCountryList] = useState([]);
  const [statusList, setStatusList] = useState([
    { value: "Approved", label: "Approved" },
    { value: "Pending", label: "Pending" },

    { value: "RAK Error", label: "RAK Error" },
    { value: "Failed to Verify", label: "Failed to Verify" },
  ]);

  useEffect(() => {
    getDropdownCountryListDD(); // TODO - ENABLE IN PRODUCTION
  }, []);

  const getDropdownCountryListDD = () => {
    getDropdownCountryList()
      .then((getDropdownCountryListRes) => {
        console.log({ getDropdownCountryListRes });
        if (getDropdownCountryListRes && getDropdownCountryListRes.data) {
          let data = getDropdownCountryListRes.data.map((element) => {
            element.label = element.name || "";
            element.value = element.code || "";
            return element;
          });
          setCountryList(data);
        }
      })
      .catch((getDropdownCountryListErr) => {
        console.log({ getDropdownCountryListErr });
        setCountryList([]);
      });
  };

  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Type"
              onChange={(data) => {
                console.log("Selected Type", data);
                setType(data);
                setTypeLength((data && data.length) || 0);
              }}
              options={typeList}
              value={type}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Country"
              onChange={(data) => {
                setCountry(data);
                setCountryLength((data && data.length) || 0);
              }}
              options={countryList}
              value={country}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Status"
              onChange={(data) => {
                setStatus(data);
                setStatusLength((data && data.length) || 0);
              }}
              options={statusList}
              value={status}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let req = {};
              req.searchStatus = status;
              req.searchCountry = country;
              req.searchType = type;
              req.typeLength = type.length;
              req.countryLength = country.length;
              req.statusLength = status.length;
              req.totalLength =
                req.typeLength + req.countryLength + req.statusLength;
              saveButtonClicked(req);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RaKBeneficiaryFilter;
